<template>
    <div
        class="app-container clearfix accountadmin"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-row :gutter="20">
            <el-col :span="xwidth">
                <el-card class="el-brand">
                    <div slot="header" class="clearfix" v-show="visible">
                        <span class="ptitle right-20">账套管理</span>
                        <el-select
                            v-model="selTenantId"
                            placeholder="请选择商户"
                            @change="TenantChange"
                            size="mini"
                            class="right-20"
                            :disabled="rightdetailShow"
                            clearable
                            filterable
                            @clear="TenantClear"
                        >
                            <el-option
                                v-for="item in Tenants"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                        <span class="ptitle right-20">软件版本</span>
                        <el-cascader
                            size="mini"
                            class="right-20"
                            :options="selSupportData"
                            placeholder="请选择财务版本"
                            :props="cascaderProps"
                            v-model="selProductId"
                            @change="cascaderChange"
                        ></el-cascader>
                        <!-- <span class="right-15 left-15">状态:</span>
                        <el-select
                            v-model="accountStatus"
                            placeholder="请选择状态"
                            size="medium"
                            @change="AccountStatusChange"
                        >
                            <el-option
                                v-for="item in statusList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select> -->

                        <el-button
                            style="float: right; padding: 3px 0"
                            size="mini"
                            icon="el-icon-plus"
                            v-if="
                                isGranted('Pages.AccountConfInfos.Create') &&
                                isMaxNum
                            "
                            @click="NewAccount"
                            >新增</el-button
                        >
                        <el-button
                            class="pull-right right-10"
                            icon="fa fa-home"
                            size="mini"
                            @click="accountSetting"
                            >账套设置</el-button
                        >
                    </div>
                    <el-col
                        :lg="18"
                        :md="20"
                        :sm="20"
                        :xs="24"
                        v-show="!visible"
                    >
                        <p><i class="el-icon-menu right-20"></i>起止日期设置</p>

                        <el-form
                            :label-position="labelPosition"
                            label-width="130px"
                            class="idadmin"
                            :model="setModel"
                            :rules="accountrules"
                            ref="refForm"
                        >
                            <el-form-item label="当前选择账套" :required="true">
                                <el-select
                                    v-model="selAccountIds"
                                    placeholder="选择账套"
                                    size="mini"
                                    class="width100"
                                    @change="accountChange"
                                    filterable
                                    multiple
                                    @remove-tag="removeTag"
                                >
                                    <el-option
                                        label="全选"
                                        value="全选"
                                    ></el-option>
                                    <el-option
                                        v-for="item in accountList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="启用时间" prop="startTime">
                                <el-date-picker
                                    v-model="setModel.startTime"
                                    style="width: 100%"
                                    placeholder="选择日期"
                                    @change="changeEnd1"
                                    :picker-options="pickerOptionsStart1"
                                ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="结束时间" prop="endTime">
                                <el-date-picker
                                    v-model="setModel.endTime"
                                    style="width: 100%"
                                    placeholder="选择日期"
                                    @change="changeStart1"
                                    :picker-options="pickerOptionsEnd1"
                                ></el-date-picker>
                            </el-form-item>

                            <el-button
                                type="info"
                                size="medium"
                                @click="setClose"
                                icon="el-icon-close"
                                >关闭</el-button
                            >
                            <el-button
                                type="primary"
                                size="medium"
                                @click="setSubmit"
                                icon="el-icon-check"
                                >保存</el-button
                            >
                        </el-form>
                    </el-col>
                    <el-col :span="24" v-show="visible">
                        <!--通告列表-->
                        <el-table :data="accountTableData" border size="mini">
                            <el-table-column label="操作" width="180px">
                                <template slot-scope="scope">
                                    <el-tooltip content="编辑" placement="top">
                                        <el-button
                                            type="primary"
                                            icon="el-icon-edit"
                                            circle
                                            v-if="
                                                isGranted(
                                                    'Pages.AccountConfInfos.Edit'
                                                )
                                            "
                                            @click="
                                                selectAccount(scope.row, true)
                                            "
                                            size="mini"
                                        ></el-button>
                                    </el-tooltip>
                                    <!-- <el-tooltip content="查看" placement="top">
                                        <el-button
                                            type="info"
                                            icon="el-icon-view"
                                            circle
                                            v-if="isGranted('Pages.AccountConfInfos.GetAll')"
                                            @click="selectAccount(scope.row, false)"
                                            size="mini"
                                        ></el-button>
                                    </el-tooltip> -->

                                    <el-tooltip content="删除" placement="top">
                                        <el-button
                                            type="danger"
                                            icon="el-icon-delete"
                                            circle
                                            v-if="
                                                isGranted(
                                                    'Pages.AccountConfInfos.Delete'
                                                )
                                            "
                                            @click="deleteAccount(scope.row.id)"
                                            size="mini"
                                        ></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="检测" placement="top">
                                        <el-button
                                            type="info"
                                            icon="el-icon-bell"
                                            circle
                                            @click="checkStatus(scope.row)"
                                            size="mini"
                                        ></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="复制" placement="top">
                                        <el-button
                                            type="info"
                                            icon="el-icon-document"
                                            circle
                                            v-show="isMaxNum"
                                            @click="copyCurrent(scope.row)"
                                            size="mini"
                                        ></el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="tenantName"
                                label="商户"
                                min-width="50px"
                            ></el-table-column>
                            <el-table-column
                                prop="name"
                                label="账套名"
                                min-width="50px"
                            ></el-table-column>
                            <el-table-column
                                prop="checkMethodAddr"
                                label="账套地址"
                            ></el-table-column>
                            <el-table-column label="配置参数">
                                <template slot-scope="scope">{{
                                    paramFormat(scope.row.params)
                                }}</template>
                            </el-table-column>
                            <el-table-column
                                prop="accountID"
                                label="账套号"
                                min-width="40px"
                            ></el-table-column>

                            <el-table-column label="软件版本" min-width="50px">
                                <template slot-scope="scope">
                                    <i
                                        :class="scope.row.color"
                                        style="margin-right: 10px"
                                    ></i>
                                    {{ erpFormat(scope.row) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="剩余(天)" min-width="40px">
                                <template slot-scope="scope">{{
                                    timeFormat(
                                        scope.row.startTime,
                                        scope.row.endTime
                                    )
                                }}</template>
                            </el-table-column>
                            <el-table-column label="状态" min-width="40px">
                                <template slot-scope="scope">
                                    <i
                                        :class="statusColor(scope.row)"
                                        style="margin-right: 10px"
                                    ></i>
                                    {{ statusFormat(scope.row) }}
                                </template>
                            </el-table-column>
                        </el-table>
                        <pagerBar
                            ref="refPagerBar"
                            :apiURL="AccountListApiUrl"
                            :GetData="getTableData"
                            :queryParam="queryParam"
                            :errorFunc="closeOpenloading"
                            :isInit="false"
                        ></pagerBar>
                    </el-col>
                </el-card>
            </el-col>
            <transition name="detailModel">
                <div v-show="rightdetailShow" style="position: relative">
                    <el-col :span="12">
                        <el-card class="box-card-detail">
                            <div slot="header" class="clearfix">
                                <span class="ptitle">{{ xtitle }}</span>
                                <el-button
                                    type="danger"
                                    icon="el-icon-close"
                                    size="mini"
                                    class="pull-right"
                                    @click="closeSub"
                                    >关闭</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="el-icon-check"
                                    size="mini"
                                    class="pull-right right-20"
                                    @click="Add"
                                    v-show="isShow"
                                    >保存</el-button
                                >
                            </div>

                            <el-tabs v-model="activeName">
                                <el-tab-pane label="基础配置" name="first">
                                    <el-form
                                        :model="accountModel"
                                        size="medium"
                                        label-width="110px"
                                        label-position="left"
                                        :rules="rules"
                                        ref="refAccount"
                                    >
                                        <el-form-item
                                            label="选择财务环境"
                                            prop="selectSupport"
                                        >
                                            <el-cascader
                                                :options="supportData"
                                                placeholder="请选择财务系统环境"
                                                style="width: 100%"
                                                :props="cascaderProps"
                                                v-model="
                                                    accountModel.selectSupport
                                                "
                                                @change="getSelSupportandParams"
                                            ></el-cascader>
                                        </el-form-item>
                                        <el-form-item label="是否多组织">
                                            <el-switch
                                                style="
                                                    display: inline-block;
                                                    margin-right: 20px;
                                                "
                                                v-model="
                                                    accountModel.isMultiOrg
                                                "
                                                active-color="#13ce66"
                                                inactive-color="#909399"
                                                active-text="开"
                                                inactive-text="关"
                                            ></el-switch>
                                        </el-form-item>
                                        <el-form-item label="分录是否合并">
                                            <el-switch
                                                style="
                                                    display: inline-block;
                                                    margin-right: 20px;
                                                "
                                                v-model="
                                                    accountModel.isMergeEntry
                                                "
                                                active-color="#13ce66"
                                                inactive-color="#909399"
                                                active-text="开"
                                                inactive-text="关"
                                            ></el-switch>
                                        </el-form-item>

                                        <el-form-item
                                            v-show="!accountModel.isMergeEntry"
                                            label="不合并规则"
                                            ><el-radio-group
                                                v-model="
                                                    accountModel.noMergeEntryType
                                                "
                                            >
                                                <el-radio :label="0"
                                                    >都不合并</el-radio
                                                >
                                                <el-radio :label="1"
                                                    >借方不合并</el-radio
                                                >
                                                <el-radio :label="2"
                                                    >贷方不合并</el-radio
                                                >
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-form-item label="名称" prop="name">
                                            <el-input
                                                v-model="accountModel.name"
                                                placeholder="请输入账套名称"
                                                prefix-icon="fa fa-tag"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="核算地址"
                                            prop="checkMethodAddr"
                                        >
                                            <el-input
                                                v-model="
                                                    accountModel.checkMethodAddr
                                                "
                                                placeholder="请输入核算地址"
                                                prefix-icon="fa fa-edge"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="账套号"
                                            prop="accountID"
                                        >
                                            <el-input
                                                v-model="accountModel.accountID"
                                                placeholder="请输入账套号"
                                                prefix-icon="fa fa-id-badge"
                                            ></el-input>
                                        </el-form-item>
                                        <div
                                            v-for="(
                                                item, index
                                            ) in accountModel.ParamArray"
                                            :key="index"
                                        >
                                            <el-form-item
                                                :label="item.name"
                                                :prop="
                                                    'ParamArray.' +
                                                    index +
                                                    '.value'
                                                "
                                            >
                                                <el-input
                                                    v-model="item.value"
                                                ></el-input>
                                            </el-form-item>
                                        </div>
                                        <el-form-item
                                            label="有效期"
                                            prop="startTime"
                                        >
                                            <el-date-picker
                                                v-model="accountModel.startTime"
                                                placeholder="选择日期时间"
                                                style="width: 48%"
                                                @change="changeEnd"
                                                :picker-options="
                                                    pickerOptionsStart
                                                "
                                            ></el-date-picker>
                                            <span
                                                style="
                                                    width: 4%;
                                                    text-align: center;
                                                    display: inline;
                                                "
                                                >-</span
                                            >
                                            <el-date-picker
                                                v-model="accountModel.endTime"
                                                placeholder="选择日期时间"
                                                style="width: 48%"
                                                class="pull-right"
                                                @change="changeStart"
                                                :picker-options="
                                                    pickerOptionsEnd
                                                "
                                            ></el-date-picker>
                                        </el-form-item>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane label="控制配置" name="second">
                                    <el-form
                                        :model="controlModel"
                                        size="medium"
                                        label-width="125px"
                                        label-position="left"
                                        ref="refControl"
                                        :rules="rulesControl"
                                    >
                                        <el-form-item
                                            label="同步模式配置"
                                            style="position: relative"
                                        >
                                            <el-select
                                                v-model="
                                                    controlModel.syncModeSetting
                                                "
                                                placeholder="请选择同步模式"
                                                size="mini"
                                                class="width100"
                                            >
                                                <el-option
                                                    v-for="item in enumSyncMode"
                                                    :key="item.id"
                                                    :label="item.content"
                                                    :value="item.id"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="异常处理机制">
                                            <el-select
                                                v-model="
                                                    controlModel.exceptionhandling
                                                "
                                                placeholder="请选择异常处理机制"
                                                size="mini"
                                                class="width100"
                                            >
                                                <el-option
                                                    v-for="item in enumException"
                                                    :key="item.id"
                                                    :label="item.content"
                                                    :value="item.id"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="电话"
                                            prop="telephone"
                                        >
                                            <el-input
                                                type="text"
                                                v-model="controlModel.telephone"
                                                placeholder="请输入电话"
                                                prefix-icon="el-icon-mobile-phone"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item label="邮箱" prop="email">
                                            <el-input
                                                type="text"
                                                v-model="controlModel.email"
                                                placeholder="请输入邮箱"
                                                prefix-icon="el-icon-message"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="基础资料自动同步"
                                            style="position: relative"
                                        >
                                            <el-switch
                                                style="
                                                    display: inline-block;
                                                    margin-right: 20px;
                                                "
                                                v-model="
                                                    controlModel.isAutoBasicAutoSync
                                                "
                                                active-color="#13ce66"
                                                inactive-color="#909399"
                                                active-text="开"
                                                inactive-text="关"
                                            ></el-switch>
                                            <el-button
                                                type="primary"
                                                size="mini"
                                                style="display: inline-block"
                                                @click="basicTongbu = true"
                                                class="right-15"
                                                >配置</el-button
                                            >
                                            <!-- <i
                        v-if="controlModel.basicDatas.length==0"
                        class="el-icon-circle-close"
                        style="color:#F56C6C"
                      ></i>
                      <i v-else class="el-icon-circle-check" style="color:#67C23A"></i>-->
                                        </el-form-item>
                                        <!-- <el-form-item label="业务单据同步配置">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="bussTongbu=true"
                        class="right-15"
                      >配置</el-button>
                       <i
                        v-if="controlModel.businessDatas.length==0"
                        class="el-icon-circle-close"
                        style="color:#F56C6C"
                      ></i>
                      <i v-else class="el-icon-circle-check" style="color:#67C23A"></i>
                    </el-form-item> -->

                                        <el-form-item label="科目类型">
                                            <el-button
                                                type="primary"
                                                size="mini"
                                                @click="isSubjectType = true"
                                                class="right-15"
                                                >配置</el-button
                                            >
                                        </el-form-item>
                                        <el-form-item
                                            label="自动传输业务单据"
                                            style="position: relative"
                                        >
                                            <el-switch
                                                style="
                                                    display: inline-block;
                                                    margin-right: 20px;
                                                "
                                                v-model="
                                                    controlModel.isAutoBussDatas
                                                "
                                                active-color="#13ce66"
                                                inactive-color="#909399"
                                                active-text="开"
                                                inactive-text="关"
                                            ></el-switch>
                                        </el-form-item>
                                        <div
                                            v-show="
                                                controlModel.isAutoBussDatas
                                            "
                                        >
                                            <el-form-item label="周期（天）">
                                                <el-input-number
                                                    v-model="
                                                        controlModel.transferDay
                                                    "
                                                    controls-position="right"
                                                    :min="1"
                                                    :max="7"
                                                ></el-input-number>
                                            </el-form-item>
                                            <el-form-item label="传输时间">
                                                <el-time-select
                                                    v-model="
                                                        controlModel.transferTime
                                                    "
                                                    :picker-options="
                                                        transferTimeOption
                                                    "
                                                    placeholder="选择传输时间"
                                                ></el-time-select>
                                            </el-form-item>
                                        </div>

                                        <el-form-item
                                            label="自动生成凭证"
                                            style="position: relative"
                                        >
                                            <el-switch
                                                style="
                                                    display: inline-block;
                                                    margin-right: 20px;
                                                "
                                                v-model="
                                                    controlModel.isAutoVoucher
                                                "
                                                active-color="#13ce66"
                                                inactive-color="#909399"
                                                active-text="开"
                                                inactive-text="关"
                                            ></el-switch>
                                        </el-form-item>
                                        <div
                                            v-show="controlModel.isAutoVoucher"
                                        >
                                            <el-form-item label="周期（天）">
                                                <el-input-number
                                                    v-model="
                                                        controlModel.voucherDay
                                                    "
                                                    controls-position="right"
                                                    :min="1"
                                                    :max="7"
                                                ></el-input-number>
                                            </el-form-item>
                                            <el-form-item label="生成时间">
                                                <el-time-select
                                                    v-model="
                                                        controlModel.voucherTime
                                                    "
                                                    :picker-options="
                                                        voucherTimeOption
                                                    "
                                                    placeholder="选择生成时间"
                                                ></el-time-select>
                                            </el-form-item>
                                        </div>
                                    </el-form>
                                </el-tab-pane>
                            </el-tabs>
                        </el-card>
                    </el-col>
                </div>
            </transition>
        </el-row>

        <el-dialog
            v-el-drag-dialog
            title="基础资料同步设置"
            :visible.sync="basicTongbu"
            center
            width="590px"
            :before-close="handleClose"
            class="tongbu"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <div style="text-align: center">
                <el-transfer
                    style="text-align: left; display: inline-block"
                    v-model="controlModel.basicDatas"
                    filterable
                    :titles="['档案数据', '同步档案']"
                    :button-texts="['删除', '添加']"
                    :props="transferProps"
                    :data="basicDatas"
                >
                    <el-tooltip
                        slot-scope="{ option }"
                        :content="option.name"
                        placement="left"
                        v-if="option.name.length >= 11"
                    >
                        <span>{{ option.name }}</span>
                    </el-tooltip>

                    <span
                        slot-scope="{ option }"
                        v-else-if="option.name.length < 11"
                        >{{ option.name }}</span
                    >
                </el-transfer>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="basicTongbu = false" size="mini"
                    >关闭</el-button
                >
            </span>
        </el-dialog>

        <el-dialog
            v-el-drag-dialog
            title="业务单据同步设置"
            :visible.sync="bussTongbu"
            center
            width="590px"
            :before-close="handleClose"
            class="tongbu"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <div style="text-align: center">
                <el-transfer
                    style="text-align: left; display: inline-block"
                    v-model="controlModel.businessDatas"
                    filterable
                    :titles="['单据类型', '同步数据']"
                    :button-texts="['删除', '添加']"
                    :props="transferProps"
                    :data="bussDatas"
                >
                    <el-tooltip
                        slot-scope="{ option }"
                        :content="option.name"
                        placement="left"
                        v-if="option.name.length >= 11"
                    >
                        <span>{{ option.name }}</span>
                    </el-tooltip>
                    <span
                        slot-scope="{ option }"
                        v-else-if="option.name.length < 11"
                        >{{ option.name }}</span
                    >
                </el-transfer>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="bussTongbu = false" size="mini"
                    >关闭</el-button
                >
            </span>
        </el-dialog>

        <el-dialog
            v-el-drag-dialog
            title="科目类型设置"
            :visible.sync="isSubjectType"
            center
            width="590px"
            :before-close="handleClose"
            class="tongbu"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <div style="text-align: center">
                <el-transfer
                    style="text-align: left; display: inline-block"
                    v-model="controlModel.subjectType"
                    filterable
                    :titles="['科目类型', '同步科目']"
                    :button-texts="['删除', '添加']"
                    :props="transferProps2"
                    :data="subjectTypeData"
                >
                    <el-tooltip
                        slot-scope="{ option }"
                        :content="option.subjectTypeName"
                        placement="left"
                        v-if="option.subjectTypeName.length >= 11"
                    >
                        <span>{{ option.subjectTypeName }}</span>
                    </el-tooltip>
                    <span
                        slot-scope="{ option }"
                        v-else-if="option.subjectTypeName.length < 11"
                        >{{ option.subjectTypeName }}</span
                    >
                </el-transfer>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isSubjectType = false" size="mini"
                    >关闭</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import config from '@/common/config.js'
import pagerBar from '@/views/pager/pagerBar'
import AjaxHelper from '@/common/js/AjaxHelper'
export default {
    data() {
        let checkPhone = (rule, value, callback) => {
            const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/
            if (!value) {
                return callback(new Error('电话号码不能为空'))
            }
            setTimeout(() => {
                // Number.isInteger是es6验证数字是否为整数的方法,但是我实际用的时候输入的数字总是识别成字符串
                // 所以我就在前面加了一个+实现隐式转换

                if (!Number.isInteger(+value)) {
                    callback(new Error('请输入数字值'))
                } else {
                    if (phoneReg.test(value)) {
                        callback()
                    } else {
                        callback(new Error('电话号码格式不正确'))
                    }
                }
            }, 100)
        }
        let checkEmail = (rule, value, callback) => {
            const mailReg =
                /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
            if (!value) {
                return callback(new Error('邮箱不能为空'))
            }
            setTimeout(() => {
                if (mailReg.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确的邮箱格式'))
                }
            }, 100)
        }
        return {
            selSupportData: [],
            statusList: [],
            accountStatus: 0,
            pickerOptionsStart1: {},
            pickerOptionsEnd1: {},
            selAccountIds: [], //选中的门店ID集合
            accountList: [],
            setModel: {
                startTime: '', //开始时间
                endTime: '' //结束时间
            },
            accountrules: {
                startTime: [
                    {
                        required: true,
                        message: '请选择开始时间',
                        trigger: 'change'
                    }
                ],
                endTime: [
                    {
                        required: true,
                        message: '请选择结束时间',
                        trigger: 'change'
                    }
                ]
            },
            visible: true,
            openloading: true,
            accountNum: 0,
            isShow: false,
            isMaxNum: false, //是否超出最大账套数
            queryParam: { tenantID: '', productID: '' }, //分页查询参数
            Tenants: [], //商户
            AccountListApiUrl:
                config.BASE_Middle_API + 'AccountConfInfos/GetAll',
            AccountConfApiUrl: config.BASE_Middle_API + 'AccountConfInfos',
            xtitle: '账套设置',
            operation: 'Add', //当前操作
            activeName: 'first', //tab切换
            basicTongbu: false, // 基础资料同步弹窗
            bussTongbu: false, //业务单据配置弹窗
            isSubjectType: false, //科目设置弹窗
            cascaderProps: { value: 'id', label: 'name' },
            transferProps: { key: 'id', label: 'name' },
            transferProps2: { key: 'id', label: 'subjectTypeName' },
            transferTimeOption: { start: '00:00', step: '00:15', end: '23:00' },
            voucherTimeOption: { start: '00:00', step: '00:15', end: '23:00' },
            basicDatas: [], //配置:基础信息
            bussDatas: [], //配置:业务单据
            subjectTypeData: [], //配置:科目类型
            enumSyncMode: [], //同步模式枚举
            enumException: [], //异常处理
            labelPosition: 'left',
            xwidth: 24,
            rightdetailShow: false, //右侧 编辑详情是否弹出
            selTenantId: '',
            selProductId: '',
            pickerOptionsStart: {},
            pickerOptionsEnd: {},
            accountModel: {
                id: null,
                name: '', //账套名称
                accountID: '', //账套号
                checkMethodAddr: '', //核算地址
                startTime: moment(), //开始时间
                endTime: moment().add(1, 'years'), //结束时间
                Params: '', //接口参数
                selectSupport: [], //财务软件版本ID
                ParamArray: [],
                isMultiOrg: false,
                isMergeEntry: false,
                noMergeEntryType: 0
            },
            controlModel: {
                syncModeSetting: 1, //同步模式
                exceptionhandling: 1, //异常处理模式
                telephone: '', //电话
                email: '', //邮箱
                transferTime: '01:00', //传输时间
                transferDay: 1, //天数
                isAutoBussDatas: true,
                isAutoBasicAutoSync: true,
                isAutoVoucher: true,
                voucherDay: 1,
                voucherTime: '03:00',
                basicDatas: [], //基础资料
                businessDatas: [], //业务单据
                subjectType: [] //科目类型
            },
            accountTableData: [], //账套列表数据
            supportData: [], //财务软件数据
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入账套名称',
                        trigger: 'blur'
                    }
                ],
                accountID: [
                    { required: true, message: '请输入账套号', trigger: 'blur' }
                ],
                checkMethodAddr: [
                    {
                        required: true,
                        message: '请输入核算地址',
                        trigger: 'blur'
                    }
                ],
                startTime: [
                    {
                        required: true,
                        message: '请选择开始时间',
                        trigger: 'change'
                    }
                ],
                endTime: [
                    {
                        required: true,
                        message: '请选择结束时间',
                        trigger: 'change'
                    }
                ],
                selectSupport: [
                    {
                        type: 'array',
                        required: true,
                        message: '请选择财务软件',
                        trigger: 'change'
                    }
                ]
            },
            CheckStatusApiUrl:
                config.BASE_Middle_API + 'apiCheck/CheckFinApiStatus',
            AccountConfCopyApiUrl:
                config.BASE_Middle_API + 'AccountConfInfos/GetCopyAccount',

            rulesControl: {
                // telephone: [{ required: true, validator: checkPhone, trigger: "blur" }],
                // // email: [{ required: true, validator: checkEmail, trigger: "blur" }]
                // email: [
                //   // { required: true, validator: checkEmail, trigger: "blur" }
                //   {
                //     required: true,
                //     message: this.L("TheFieldIsRequired", this.L("EmailAddress")),
                //     trigger: "blur,change",
                //   },
                //   {
                //     type: "email",
                //     message: this.L("InvalidEmailAddress"),
                //     trigger: "blur,change",
                //   },
                // ],
            }
        }
    },
    components: {
        pagerBar
    },
    mounted: function () {
        // this.getSupportCasData();
        this.InitData()
        this.changeStart1()
        this.changeEnd1()
        this.getAllSupportCasData()
        this.statusList.push({ id: 0, name: '全部' })
        this.statusList.push({ id: 1, name: '未启用' })
        this.statusList.push({ id: 2, name: '即将过期' })
        this.statusList.push({ id: 3, name: '过期失效' })
        this.statusList.push({ id: 4, name: '有效' })
    },
    methods: {
        TenantChange(tenantID) {
            this.openloading = true
            this.selTenantId = tenantID
            this.queryParam.tenantID = tenantID
            if (tenantID != 0) {
                this.getSupportCasData(tenantID)
            }
        },

        // AccountStatusChange(val) {
        //     this.accountStatus = val
        //     this.queryParam.accountStatus = val
        //     if (this.selTenantId == '' || this.selTenantId == 0) {
        //         this.TenantChange(0)
        //     }
        // },
        TenantClear() {
            this.queryParam.tenantID = 0
            if (this.selTenantId == '') {
                this.TenantChange(0)
            }
        },
        getAllSupportCasData() {
            //获取财务版本信息 绑定级联选择控件
            const _this = this
            AjaxHelper.get(_this.AccountConfApiUrl + '/GetTreeTwoLevels', {})
                .then(function (response) {
                    if (response.success) {
                        _this.selSupportData = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        cascaderChange(val) {
            this.productID = val[1]
            this.queryParam.productID = val[1]
            if (this.selTenantId == '') {
                this.TenantChange(0)
            }
            if (this.accountStatus == '') {
                this.queryParam.accountStatus = 0
            }
        },
        setClose() {
            //关闭配置页面
            this.visible = true
            if (this.$refs['refForm']) {
                this.$refs['refForm'].resetFields()
            }
            this.selAccountIds = []
        },
        setSubmit() {
            //配置提交
            const _this = this
            _this.$refs['refForm'].validate((valid) => {
                if (valid) {
                    if (_this.selAccountIds.length == 0) {
                        _this.$notify({
                            title: '提示',
                            message: '请选择要设置的账套',
                            type: 'error',
                            position: 'bottom-right',
                            duration: 0
                        })
                        return
                    }
                    _this.openloading = true
                    let confirmData = {}
                    confirmData = Object.assign({}, _this.setModel)
                    confirmData.startTime = moment(
                        _this.setModel.startTime
                    ).format('YYYY-MM-DD')
                    confirmData.endTime = moment(_this.setModel.endTime).format(
                        'YYYY-MM-DD'
                    )
                    // confirmData.storeIds = _this.selStoreIds;
                    let shopIds = []
                    _this.selAccountIds.forEach((t) => {
                        if (t != '全选') {
                            shopIds.push(t)
                        }
                    })
                    confirmData.accountIds = shopIds
                    AjaxHelper.post(
                        _this.AccountConfApiUrl + '/EditBatchTime',
                        confirmData
                    )
                        .then(function (response) {
                            if (response.success) {
                                _this.$notify({
                                    title: '提示',
                                    message: '批量配置成功',
                                    type: 'success',
                                    position: 'bottom-right'
                                })
                                _this.setModel = {}
                                _this.selAccountIds = []

                                _this.visible = true
                                _this.openloading = false
                                _this.$refs['refForm'].resetFields()
                                _this.setModel = {
                                    startTime: moment(), //开始时间
                                    endTime: moment() //结束时间
                                }
                                _this.Refresh()
                            }
                        })
                        .catch(function (error) {
                            console.log(error)
                        })
                }
            })
        },

        changeStart1() {
            this.pickerOptionsStart1 = Object.assign(
                {},
                this.pickerOptionsStart1,
                {
                    disabledDate: (time) => {
                        return time.getTime() > this.setModel.endTime
                    }
                }
            )
        },
        changeEnd1() {
            this.pickerOptionsEnd1 = Object.assign({}, this.pickerOptionsEnd1, {
                disabledDate: (time) => {
                    return time.getTime() < this.setModel.startTime
                }
            })
        },
        removeTag(val) {
            if (val === '全选') {
                this.selAccountIds = []
            }
        },
        accountChange(val) {
            var end = val[val.length - 1]
            if (
                !val.includes('全选') &&
                val.length === this.accountList.length
            ) {
                val.unshift('全选')
            } else if (val.includes('全选') && val.length == 1) {
                this.accountList.map((item) => {
                    val.push(item.id)
                })
            } else if (
                val.includes('全选') &&
                val.length - 1 < this.accountList.length &&
                end == '全选'
            ) {
                val = []
                this.accountList.map((item) => {
                    val.push(item.id)
                })
                val.unshift('全选')
                // this.value = val;
            } else if (
                val.includes('全选') &&
                val.length - 1 < this.accountList.length
            ) {
                val = val.filter((item) => {
                    return item !== '全选'
                })
                // this.value = val;
            }
            // 注意，加上  this.value = val，确保勾选值同步
            this.selAccountIds = val
        },

        copyCurrent(item) {
            const _this = this
            _this.openloading = true
            AjaxHelper.get(_this.AccountConfCopyApiUrl, {
                accountId: item.id
            })
                .then(function (response) {
                    if (response.success) {
                        _this.$notify({
                            title: '提示',
                            message: '复制成功',
                            type: 'success',
                            position: 'bottom-right'
                        })
                    } else {
                        _this.$notify({
                            title: '提示',
                            message: '复制失败',
                            type: 'error',
                            position: 'bottom-right'
                        })
                    }
                    _this.openloading = false
                    _this.queryParam.tenantID = item.tenantID
                    _this.selTenantId = item.tenantID
                    _this.Refresh()
                })
                .catch(function (error) {
                    _this.openloading = false
                })
        },
        checkStatus(item) {
            const _this = this
            _this.openloading = true
            const confirmData = {
                accountId: item.id
            }
            AjaxHelper.post(_this.CheckStatusApiUrl, confirmData)
                .then(function (response) {
                    if (response.result) {
                        _this.$notify({
                            title: '提示',
                            message: 'API接口状态正常',
                            type: 'success',
                            position: 'bottom-right'
                        })
                    } else {
                        _this.$notify({
                            title: '提示',
                            message: 'API接口连接失败，请检查相关参数',
                            type: 'error',
                            position: 'bottom-right'
                        })
                    }
                    _this.openloading = false
                })
                .catch(function (error) {
                    _this.openloading = false
                })
        },
        changeStart() {
            this.pickerOptionsStart = Object.assign(
                {},
                this.pickerOptionsStart,
                {
                    disabledDate: (time) => {
                        return time.getTime() > this.accountModel.endTime
                    }
                }
            )
        },
        changeEnd() {
            this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
                disabledDate: (time) => {
                    return time.getTime() < this.accountModel.startTime
                }
            })
        },

        accountSetting() {
            //门店设置
            const _this = this
            AjaxHelper.get(_this.AccountConfApiUrl + '/GetCurrentAccount', {
                tenantID: _this.selTenantId
            })
                .then(function (response) {
                    if (response.success) {
                        _this.accountList = response.result.accountList
                        _this.setModel.startTime = response.result.startTime
                        _this.setModel.endTime = response.result.endTime

                        _this.visible = false
                        _this.selAccountIds = []
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
            this.visible = false
        },

        getTenants() {
            const _this = this
            AjaxHelper.get(_this.AccountConfApiUrl + '/GetTenants')
                .then(function (response) {
                    if (response.success) {
                        _this.Tenants = response.result
                        _this.Tenants.unshift({
                            name: '全部',
                            id: 0
                        })
                        _this.openloading = false
                    }
                })
                .catch(function (error) {
                    _this.openloading = false
                })
        },
        InitData() {
            //初始化页面参数  枚举列表
            this.getTenants()
            this.getEunmsException()
            this.getEnumsSyncMode()
            this.getBasicData()
            this.getSubjectType()
            this.changeStart()
            this.changeEnd()
        },
        getSubjectType() {
            const _this = this
            AjaxHelper.get(_this.AccountConfApiUrl + '/GetAllSujectType', {})
                .then(function (response) {
                    if (response.success) {
                        _this.subjectTypeData = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        getBussOrderData(versionID, isClear) {
            const _this = this
            AjaxHelper.get(_this.AccountConfApiUrl + '/GetOrderData', {
                versionID: versionID
            })
                .then(function (response) {
                    if (response.success) {
                        _this.bussDatas = response.result
                        if (isClear) {
                            _this.controlModel.businessDatas = []
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        getBasicData() {
            const _this = this
            AjaxHelper.get(_this.AccountConfApiUrl + '/GetListForSelect', {})
                .then(function (response) {
                    if (response.success) {
                        _this.basicDatas = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        getAccountNum(tenantID) {
            const _this = this
            AjaxHelper.get(_this.AccountConfApiUrl + '/GetAccountNum', {
                tenantID: tenantID
            })
                .then(function (response) {
                    if (response.success) {
                        _this.accountNum = response.result
                        if (
                            _this.$refs.refPagerBar.pagerTotal >=
                            _this.accountNum
                        ) {
                            _this.isMaxNum = false
                        } else {
                            _this.isMaxNum = true
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        getTableData(data) {
            this.accountTableData = data
            this.openloading = false
            if (this.selTenantId == '') {
                this.getAccountNum(0)
            } else {
                this.getAccountNum(this.selTenantId)
            }
        },
        closeOpenloading() {
            this.openloading = false
        },
        getSelSupportandParams(val) {
            const _this = this
            const versionID = val[2]
            AjaxHelper.get(_this.AccountConfApiUrl + '/GetParams', {
                versionID: versionID
            })
                .then(function (response) {
                    if (response.success) {
                        _this.accountModel.selectSupport =
                            response.result.selectSupport
                        const vaildParms = response.result.params.split(',')
                        _this.accountModel.ParamArray = []
                        vaildParms.forEach((element) => {
                            _this.accountModel.ParamArray.push({
                                name: element,
                                value: ''
                            })
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })

            // _this.getBussOrderData(versionID, true);
        },
        getEunmsException() {
            const _this = this
            AjaxHelper.get(_this.AccountConfApiUrl + '/GetEnumsException', {})
                .then(function (response) {
                    if (response.success) {
                        _this.enumException = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        getEnumsSyncMode() {
            const _this = this
            AjaxHelper.get(_this.AccountConfApiUrl + '/GetEnumsSyncMode', {})
                .then(function (response) {
                    if (response.success) {
                        _this.enumSyncMode = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        getSupportCasData(tenantID) {
            //获取财务版本信息 绑定级联选择控件
            const _this = this
            AjaxHelper.get(_this.AccountConfApiUrl + '/GetSupportTree', {
                tenantID: tenantID
            })
                .then(function (response) {
                    if (response.success) {
                        _this.supportData = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        timeFormat(start, end) {
            const nowDate = moment().format('YYYY-MM-DD') //获取当前时间 排除时分秒 按整天
            const nowDays = moment(nowDate).diff(
                moment(start).format('YYYY-MM-DD'),
                'days'
            )
            if (nowDays < 0) {
                const daysone =
                    moment(end).diff(
                        moment(start).format('YYYY-MM-DD'),
                        'days'
                    ) + 1
                return daysone
            } else {
                const days =
                    moment(end).diff(
                        new moment().format('YYYY-MM-DD'),
                        'days'
                    ) + 1
                if (days <= 0) {
                    return '0'
                }
                return days
            }
        },
        paramFormat(params) {
            const paramsObj = JSON.parse(params)
            let format_Str = ''
            paramsObj.forEach((x) => {
                format_Str += x.name + ':' + x.value + ','
            })
            const reg = /,$/gi
            format_Str = format_Str.replace(reg, '')
            return format_Str
        },
        erpFormat(item) {
            return (
                item.supportName +
                '/' +
                item.productName +
                '/' +
                item.versionName
            )
        },
        statusFormat(item) {
            const nowDate = moment().format('YYYY-MM-DD') //获取当前时间 排除时分秒 按整天
            const nowDays = moment(nowDate).diff(
                moment(item.startTime).format('YYYY-MM-DD'),
                'days'
            )
            if (nowDays < 0) {
                return '未启用'
            } else {
                const days =
                    moment(item.endTime).diff(
                        new moment().format('YYYY-MM-DD'),
                        'days'
                    ) + 1 //结束时间算一天 需+1
                if (days < 30 && days > 0) {
                    return '即将到期'
                } else if (days <= 0) {
                    return '过期失效'
                } else {
                    return '有效'
                }
            }
        },
        statusColor(item) {
            const nowDate = moment().format('YYYY-MM-DD') //获取当前时间 排除时分秒 按整天
            const nowDays = moment(nowDate).diff(
                moment(item.startTime).format('YYYY-MM-DD'),
                'days'
            )
            if (nowDays < 0) {
                return 'fa fa-circle el-info'
            } else {
                const days =
                    moment(item.endTime).diff(
                        new moment().format('YYYY-MM-DD'),
                        'days'
                    ) + 1
                if (days < 30 && days > 0) {
                    return 'fa fa-circle el-warning'
                } else if (days <= 0) {
                    return 'fa fa-circle el-danger'
                } else {
                    return 'fa fa-circle el-success'
                }
            }
        },
        clearFormValidate() {
            //清除表单的验证信息
            if (this.$refs['refAccount']) {
                this.$refs['refAccount'].clearValidate()
            }
            if (this.$refs['refControl']) {
                this.$refs['refControl'].clearValidate()
            }
        },
        Add() {
            //新增套账提交
            const _this = this
            const validForm = ['refAccount', 'refControl'] //需验证的表单 ref值
            const postUrl = _this.AccountConfApiUrl + '/CreateOrEdit'
            let validArr = []
            //生成凭证的时间要大于传输业务单据的时间两个小时。
            if (
                _this.controlModel.isAutoBussDatas &&
                _this.controlModel.isAutoVoucher
            ) {
                var transferTime = moment(
                    moment().format('YYYY-MM-DD') +
                        ' ' +
                        _this.controlModel.transferTime
                )
                var voucherTime = moment(
                    moment().format('YYYY-MM-DD') +
                        ' ' +
                        _this.controlModel.voucherTime
                )
                if (voucherTime.diff(transferTime, 'hours') < 2) {
                    _this.$message({
                        type: 'error',
                        message:
                            '生成凭证的时间要大于传输业务单据的时间两个小时。'
                    })
                    return false
                }
            }
            //判断账套数是否超出最大上限
            if (!_this.isMaxNum && _this.operation != 'Edit') {
                _this.$message({
                    type: 'error',
                    message: '以超出最大账套数量,如需新增请购买。'
                })
                return false
            }
            const days = moment(_this.accountModel.endTime).diff(
                moment(_this.accountModel.startTime),
                'days'
            )
            if (days < 0) {
                //判断启用时间是否大于结束时间
                this.$message({
                    type: 'error',
                    message: '启用时间大于结束时间'
                })
                return false
            }
            //判断单据配置
            // if (_this.controlModel.basicDatas.length <= 0) {
            //   _this.$message({
            //     type: "error",
            //     message: "请配置基础资料"
            //   });
            //   return false;
            // } else if (_this.controlModel.businessDatas.length <= 0) {
            //   _this.$message({
            //     type: "error",
            //     message: "请配置业务单据"
            //   });
            //   return false;
            // }

            //验证表单方法
            function checkForm(formName) {
                const result = new Promise(function (resolve, reject) {
                    _this.$refs[formName].validate((valid) => {
                        if (valid) {
                            resolve()
                        } else {
                            reject()
                        }
                    })
                })
                validArr.push(result)
            }

            //循环验证所有的表单
            validForm.forEach((item) => {
                checkForm(item)
            })
            let id = null
            if (_this.operation == 'Edit') {
                id = _this.accountModel.id
            }
            //提交数据
            const confirmData = {
                id: id,
                name: _this.accountModel.name,
                accountID: _this.accountModel.accountID,
                isMultiOrg: _this.accountModel.isMultiOrg,
                checkMethodAddr: _this.accountModel.checkMethodAddr,
                startTime: new moment(_this.accountModel.startTime).format(
                    'YYYY-MM-DD'
                ),
                endTime: new moment(_this.accountModel.endTime).format(
                    'YYYY-MM-DD'
                ),
                Params: JSON.stringify(_this.accountModel.ParamArray),
                versionID: _this.accountModel.selectSupport[2],
                syncModeSetting: _this.controlModel.syncModeSetting,
                isAutoBasicAutoSync: _this.controlModel.isAutoBasicAutoSync,
                telephone: _this.controlModel.telephone,
                email: _this.controlModel.email,
                transferTime: _this.controlModel.transferTime,
                transferDay: _this.controlModel.transferDay,
                isAutoVoucher: _this.controlModel.isAutoVoucher,
                voucherDay: _this.controlModel.voucherDay,
                voucherTime: _this.controlModel.voucherTime,
                isAutoBussDatas: _this.controlModel.isAutoBussDatas,
                basicDatas: _this.controlModel.basicDatas.join(','),
                businessDatas: _this.controlModel.businessDatas.join(','),
                subjectType: _this.controlModel.subjectType.join(','),
                exceptionhandling: _this.controlModel.exceptionhandling,
                tenantID: _this.selTenantId,
                isMergeEntry: _this.accountModel.isMergeEntry,
                noMergeEntryType: _this.accountModel.noMergeEntryType
            }
            Promise.all(validArr)
                .then(function () {
                    setTimeout(function () {
                        AjaxHelper.post(postUrl, confirmData)
                            .then(function (response) {
                                if (response.success) {
                                    _this.$message({
                                        type: 'success',
                                        message: '保存成功'
                                    })
                                    _this.Refresh()
                                    _this.initModel()
                                } else {
                                    _this.$message({
                                        type: 'error',
                                        message: '保存失败'
                                    })
                                }
                            })
                            .catch(function (error) {})
                    })
                })
                .catch(function () {
                    // _this.$message({
                    //   type: "error",
                    //   message: "请确认数据是否都填写正确"
                    // });
                })
        },

        deleteAccount(id) {
            //删除品牌数据
            const _this = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    const confirmData = { Id: id }
                    AjaxHelper.delete(
                        _this.AccountConfApiUrl + '/Delete',
                        confirmData
                    )
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                })

                                _this.Refresh()
                            } else {
                                _this.$message({
                                    type: 'error',
                                    message: response.error.message
                                })
                            }
                        })
                        .catch(function (error) {})
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        handleClose(done) {
            done()
        },
        Refresh() {
            this.xwidth = 24
            this.rightdetailShow = false
            this.$refs.refPagerBar.Refresh()
        },
        closeSub() {
            //关闭右侧弹窗
            this.rightdetailShow = false
            this.xwidth = 24
        },
        selectAccount(item, isEdit) {
            this.getSupportCasData(item.tenantID)

            if (item === null) {
                return false
            }
            this.clearFormValidate()
            const _this = this
            this.activeName = 'first'
            if (isEdit) {
                this.xtitle = '修改账套'
                this.xwidth = 12
                this.rightdetailShow = true
                this.operation = 'Edit'
            } else {
                this.xtitle = '查看账套'
                this.xwidth = 12
                this.rightdetailShow = true
                this.operation = 'Edit'
            }
            AjaxHelper.get(_this.AccountConfApiUrl + '/GetModel', {
                id: item.id
            })
                .then(function (response) {
                    if (response.success) {
                        let model = response.result.confInfoDto

                        if (isEdit) {
                            let days = moment(model.endTime).diff(
                                new moment(),
                                'days'
                            )
                            if (days <= 0) {
                                _this.isShow = true
                            } else {
                                _this.isShow = true
                            }
                        } else {
                            _this.isShow = false
                        }
                        _this.accountModel.id = model.id
                        _this.accountModel.name = model.name
                        _this.accountModel.accountID = model.accountID
                        _this.accountModel.checkMethodAddr =
                            model.checkMethodAddr
                        _this.accountModel.startTime = moment(model.startTime)
                        _this.accountModel.endTime = moment(model.endTime)
                        _this.accountModel.VersionID = model.VersionID
                        _this.accountModel.selectSupport =
                            response.result.selectSupport
                        _this.accountModel.isMultiOrg = model.isMultiOrg

                        _this.controlModel.syncModeSetting =
                            model.syncModeSetting
                        _this.controlModel.exceptionhandling =
                            model.exceptionhandling
                        _this.controlModel.telephone = model.telephone
                        _this.controlModel.email = model.email
                        _this.controlModel.transferTime = model.transferTime
                        _this.controlModel.transferDay = model.transferDay
                        _this.controlModel.isAutoBussDatas =
                            model.isAutoBussDatas
                        _this.controlModel.isAutoBasicAutoSync =
                            model.isAutoBasicAutoSync
                        _this.controlModel.isAutoVoucher = model.isAutoVoucher
                        _this.controlModel.voucherDay = model.voucherDay
                        _this.controlModel.voucherTime = model.voucherTime
                        _this.accountModel.isMergeEntry = model.isMergeEntry
                        _this.accountModel.noMergeEntryType =
                            model.noMergeEntryType
                        _this.controlModel.basicDatas = [
                            ...model.basicDatas.split(',').map((x) => {
                                return Number(x)
                            })
                        ]
                        if (model.subjectType) {
                            _this.controlModel.subjectType = [
                                ...model.subjectType.split(',').map((x) => {
                                    return Number(x)
                                })
                            ]
                        }
                        _this.controlModel.businessDatas = [
                            ...model.businessDatas.split(',').map((x) => {
                                return Number(x)
                            })
                        ]
                        _this.accountModel.ParamArray = []
                        let vaildParam = JSON.parse(model.params)
                        let productParams = response.result.params.split(',')
                        productParams.forEach((e) => {
                            let hasData = vaildParam.filter((x) => x.name == e)
                            if (hasData.length > 0) {
                                _this.accountModel.ParamArray.push({
                                    name: hasData[0].name,
                                    value: hasData[0].value
                                })
                            } else {
                                _this.accountModel.ParamArray.push({
                                    name: e,
                                    value: ''
                                })
                            }
                        })
                        // _this.getBussOrderData(response.result.selectSupport[2], false);
                        _this.changeStart()
                        _this.changeEnd()
                    }
                })
                .catch(function (error) {})
        },
        NewAccount() {
            //单击新增按钮弹出Dialog
            this.initModel()
            this.xwidth = 12
            this.rightdetailShow = true
            this.xtitle = '新增账套'
            this.isShow = true
            this.operation = 'Add'
            this.activeName = 'first'
        },
        initModel() {
            this.xtitle = '账套信息'
            this.operation = 'Add'
            this.isShow = false
            if (this.$refs['refAccount']) {
                this.$refs['refAccount'].resetFields()
                this.accountModel.ParamArray = []
                this.accountModel.id = null
            }
            if (this.$refs['refControl']) {
                this.$refs['refControl'].resetFields()
                this.controlModel = {
                    syncModeSetting: 1, //同步模式
                    exceptionhandling: 1, //异常处理模式
                    transferTime: '01:00', //传输时间
                    transferDay: 1, //天数
                    isAutoBussDatas: true,
                    isAutoBasicAutoSync: true,
                    isAutoVoucher: true,
                    voucherDay: 1,
                    voucherTime: '03:00',
                    basicDatas: [], //基础资料
                    businessDatas: [], //业务单据
                    subjectType: [],
                    telephone: '', //电话
                    email: '' //邮箱
                }
            }

            // this.accountModel.ParamArray.forEach(element => {
            //   element.value = '';
            // });
        }
    }
}
</script>

<style scoped="scoped">
.accountadmin .el-card {
    height: calc(100vh - 154px);
}
.el-brand .listitem i {
    color: red;
}
.idadmin .el-form-item__content {
    line-height: none !important;
}
.bottomBtn .el-button {
    width: 200px;
    margin-top: 15px;
}
.noticeDialog h3 span {
    font-size: 13px;
}

.notify_p {
    text-indent: 2em;
    line-height: 2;
    padding: 5px 0;
}
.red {
    color: red;
}
</style>

<style>
.detailModel-enter-active {
    animation: bounce-in 0.5s;
}
@keyframes bounce-in {
    0% {
        right: -700px;
        top: 0px;
    }
    100% {
        right: 0px;
        top: 0px;
    }
}
.idadmin .el-form-item__content {
    line-height: 20px !important;
}
</style>
